import { NavLink, useMatch } from 'react-router-dom'
import { classNames } from 'utils'
import { MenuLinkProps } from './types'

export const MenuLink = (props: MenuLinkProps) => {
	const {
		icon,
		disabled,
		highlightLabel,
		label,
		onClickWithNavigation,
		onClickWithoutNavigation
	} = props

	const match = useMatch({
		path: props.to()
	})
	const isActive = highlightLabel && match
	return (
		<div
			className={`overflow-hidden !mt-0 ${props.className || ''}`}
			{...(onClickWithNavigation && {
				...{ onClick: () => onClickWithNavigation() }
			})}
		>
			<NavLink
				to={props.disabled ? '#' : props.to()}
				className={classNames(
					'flex items-center py-2 pl-4 text-[14px] rounded-xl cursor-pointer',
					isActive
						? 'bg-brand-100 font-medium'
						: 'font-normal hover:bg-t-google-btn',
					props.className || ''
				)}
				{...(onClickWithoutNavigation && {
					...{
						onClick: (e) => {
							e.preventDefault()
							onClickWithoutNavigation()
						}
					}
				})}
			>
				{icon && <props.icon className="text-t-menu flex-shrink-0 h-4 w-4" />}
				<div
					className={`flex justify-center items-center gap-2 ${
						disabled
							? 'text-t-tertiary'
							: isActive
							? 'text-t-coupon'
							: 'text-t-desc-gray'
					}`}
				>
					{label}
				</div>
			</NavLink>
		</div>
	)
}
